import { List } from 'immutable';
import { TypeItemGalleries } from 'records/TypeItemGallery';
import BaseList from 'records/BaseList';

import {
  TYPEITEM_GALLERIES_ASYNC_ACTION_START,
  TYPEITEM_GALLERIES_ASYNC_ACTION_ERROR,
  TYPEITEM_GALLERIES_ASYNC_ACTION_SUCCESS,
  TYPEITEM_GALLERIES_RESET_STATE,
} from 'actions/typeItemGalleries';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [TYPEITEM_GALLERIES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [TYPEITEM_GALLERIES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [TYPEITEM_GALLERIES_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: TypeItemGalleries(action.data),
    });
  },
  [TYPEITEM_GALLERIES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function typeItemGalleries(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
